module.exports = __webpack_public_path__ + "static/media/toilet.267be1c9.svg";